<template>
    <div class="user-management">
        <el-dialog
            :visible.sync="dialog.visible"
            @close="handleCancel()"
            width="30%">
            <div slot="title" class="dialog-title">
                <div class="title-dot"></div>
                {{dialog.title}}
            </div>

            <el-form :model="dialog.content" ref="formContent" label-width="112px">
                <el-form-item label="所属门店: ">
                    <el-select clearable v-model="dialog.content.storeId" placeholder="请选择所属门店">
                        <el-option v-for="item in storeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select> 
                </el-form-item>
                <el-form-item label="用户角色: ">
                    <el-select clearable v-model="dialog.content.roleId" placeholder="请选择用户角色" multiple="true">
                        <el-option v-for="item in roleList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select> 
                </el-form-item>
                <el-form-item label="用户名: ">
                    <el-input v-model="dialog.content.username" placeholder="请输入用户名"></el-input>
                </el-form-item>
                <el-form-item label="密码: ">
                    <el-input v-model="dialog.content.password" placeholder="请输入密码"></el-input>
                </el-form-item>
                <el-form-item label="联系方式: ">
                    <el-input v-model="dialog.content.userPhone" placeholder="请输入联系方式"></el-input>
                </el-form-item>
                <el-form-item label="真实姓名: ">
                    <el-input v-model="dialog.content.realName" placeholder="请输入真实姓名"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="cancel"  size="small" @click="handleCancel()">取消</el-button>
                <el-button type="primary" size="small" @click="submit()">确定</el-button>
            </span>
        </el-dialog>
        <div class="el-card-title">
            <span>用户列表</span>
            <div :style="{ display: 'flex' }">
                <el-tooltip effect="dark" content="新增用户" placement="top">
                    <el-button type="text" @click="handleUserInsert">
                        <i class="mdi mdi-24px mdi-plus"></i>
                    </el-button>
                </el-tooltip>
            </div>
        </div>
        <custom-table :table="tableData" :options="{
            maxHeight: 640
        }"></custom-table>
    </div>
</template>

<script>
import { UserManagementApi } from '../http/userManagement/userManagement';
import { CommonApi } from '../http/common';
import CustomTable from '../components/customTable.vue';
export default {
    name: "user-management",
    components: {
        CustomTable
    },
    data(){
        return {
            storeList: [],
            roleList: [],
            tableData: {
                data: [],
                columns: [],
                tableLoading: false
            },
            pageCfg: {
                pageSize: 15,
                currentPage: 1,
                storeId: null,
                username: "",
                realName: ""
            },
            dialog: {
                title: "",
                visible: false,
                type: "",
                content: {
                    storeId: "",
                    userPhone: "",
                    username: "",
                    password: "",
                    roleId: []
                }
            }
        }
    },
    mounted(){
        this.getStoreList();
        this.getRoleList();
        this.getUserList();
    },
    methods: {
        getStoreList(){
            CommonApi.getStoreSelectorList().then(res => {
                this.storeList = res;
            })
        },
        getRoleList(){
            CommonApi.getRoleSelectorList().then(res => {
                this.roleList = res;
            })
        },
        getUserList(){
            this.tableData.tableLoading = true;
            UserManagementApi.getUserList(this.pageCfg).then(res => {
                this.tableData.tableLoading = false;
                Object.assign(this.tableData, res);
            })
        },
        handleCancel(){
            this.dialog.visible = false;
            for(let key in this.dialog.content){
                this.dialog.content[key] = "";
            }
        },
        handleUserInsert(){
            this.dialog.visible = true;
            this.dialog.title = "新增用户";
            this.dialog.type = 'insert';
        },
        submit(){
            this.dialog.content.roleId = this.dialog.content.roleId.join(",");
            UserManagementApi.insertUser(this.dialog.content).then(res => {
                if(res.data.status === 200){
                    this.$notify.success({ title: '新增用户成功' });
                    this.handleCancel();
                    this.getUserList();
                }
            })
        }
    }
}
</script>

<style lang="less">
div.user-management{
    // padding: 14px 20px;
}
</style>